import { render, staticRenderFns } from "./IconPaymentDebitCard.vue?vue&type=template&id=d70a6d82&scoped=true"
import script from "./IconPaymentDebitCard.vue?vue&type=script&lang=js"
export * from "./IconPaymentDebitCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d70a6d82",
  null
  
)

export default component.exports